import React, { useContext, useMemo, useState } from "react";

import { CButton } from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import { elementToPDF } from "../../../../utils/export";
import Charts from "../../../Charts";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import "./styles.scss";
import { DataContext } from "../../Context/DataContext";

const HistogramaEscola = ({ activity_id: activityId }) => {
  const { schoolHistogram, loading, firstLoad, school, fetchData } =
    useContext(DataContext);
  const token = useSelector(state => state.user.token);

  const [schoolId, setSchoolId] = school;
  const [data, setData] = useState(schoolHistogram);

  const labels = useMemo(() => {
    const labelsArray = [];

    for (let index = 0; index < data.max; index++) {
      labelsArray.push(
        `De ${data.max * 0.1 * index} a ${(
          data.max * 0.1 * index +
          0.9
        ).toFixed(1)}`
      );
    }

    labelsArray.push(data.max);

    return labelsArray;
  }, [data]);

  const [formattedHistogram, selectedSchoolBracket] = useMemo(() => {
    if (!data?.grades) return [];

    const histogramArray = new Array(11).fill(0);
    const selectedBracket = new Array(11).fill(0);

    const grade =
      data.grades?.find(item => item.school_id === schoolId)?.grade || 0;
    const gradeBracket = Math.floor(grade);

    data.grades.forEach(item => {
      if (Math.floor(item.grade) === gradeBracket)
        selectedBracket[Math.floor(Number(item.grade))] += 1;
      else histogramArray[Math.floor(Number(item.grade))] += 1;
    });

    return [histogramArray, selectedBracket];
  }, [data]);

  const route = "statistics/evaluation_histograms";

  const changeFilter = selected => {
    if (selected.groupId === 0) {
      return;
    }

    if (selected.regionId === 0) {
      toastr.warning("Atenção", "Preencha o regional");
      return;
    }

    if (selected.schoolId === 0) {
      toastr.warning("Atenção", "Preencha a escola");
      return;
    }

    setSchoolId(selected.schoolId);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      activity_id: activityId
    };

    fetchData(params, token, route, setData);
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser
          hideRoom
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : data?.grades?.length > 0 && data ? (
          <div className="w-100">
            <div className="d-flex w-100 justify-content-end mt-3 mb-2">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF("toPrint", "Histograma dos Escolas.pdf")
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
              </CButton>
            </div>
            <div className="w-100" id="toPrint">
              <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                <div className="row">
                  <div className="chart w-100">
                    <Charts
                      legendX="Média"
                      legendY="Total de Escolas"
                      type="bar"
                      title="Histograma das Escolas"
                      data={{
                        labels,
                        datasets: [
                          {
                            data: formattedHistogram,
                            label: "Histograma das Escolas",
                            backgroundColor: "rgba(54, 162, 235, 0.2)",
                            borderColor: "rgba(54, 162, 235, 1)",
                            borderWidth: 1
                          },
                          {
                            data: selectedSchoolBracket,
                            label: "Escola selecionada",
                            backgroundColor: "rgba(255, 99, 132, 0.2)",
                            borderColor: "rgba(255, 99, 132, 1)",
                            borderWidth: 1
                          }
                        ]
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : firstLoad ? (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Selecione os filtros para pesquisar
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Nenhuma aplicação da avaliação foi encontrada
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistogramaEscola;
